import getGlobalAssetUrl from 'shared/utils/getGlobalAssetUrl'

const { REACT_APP_VERSION: appVersion } = process.env

const PROCESS_DEFINITION_NAMESPACE = 'processDefinition'

export const getLocaleLoadPath = (_languages: string[], namespaces: string[]): string => {
    if (namespaces[0] === PROCESS_DEFINITION_NAMESPACE) {
        return getGlobalAssetUrl('skynet/poeditor/serviceprocess/{{lng}}/ServiceProcessDefinitions.json')
    }

    return `/locales/{{lng}}/{{ns}}.json?v=${appVersion || ''}`
}

export const logFailedLocaleLoading = (lng: string, ns: string, message: string): void => {
    // eslint-disable-next-line no-console
    console.error(`Failed to load "${ns}" translations for "${lng}": ${message}`)
}
